import React from "react";
import { motion } from "framer-motion";
import { Mail, Phone, Linkedin, MapPin, Copy, Check } from "lucide-react";
import { profile } from "../../data/portfolio";

const useCopy = () => {
  const [copied, setCopied] = React.useState(null);
  const copy = (v, id) => {
    navigator.clipboard?.writeText(v);
    setCopied(id);
    setTimeout(() => setCopied(null), 1500);
  };
  return { copied, copy };
};

export const Contact = () => {
  const { copied, copy } = useCopy();

  const items = [
    { id: "email", icon: Mail, label: "Email", value: profile.email, href: `mailto:${profile.email}` },
    { id: "phone", icon: Phone, label: "Phone", value: profile.phone, href: `tel:${profile.phone.replace(/s+/g, "")}` },
    { id: "linkedin", icon: Linkedin, label: "LinkedIn", value: "sivasakthivelan", href: profile.linkedin },
    { id: "location", icon: MapPin, label: "Location", value: profile.location, href: null },
  ];

  return (
    <section id="contact" data-testid="contact-section" className="relative py-24 md:py-32 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-10 items-start">
          <div className="md:col-span-5">
            <div className="text-xs font-mono-display uppercase tracking-widest text-[color:var(--primary)] mb-3">
              /07 · Contact
            </div>
            <h2 className="font-mono-display text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-bold leading-[1.05]">
              Let&apos;s build the
              <br />
              <span className="text-gradient-neon">next intelligent</span>
              <br /> thing. →
            </h2>
            <p className="mt-6 text-white/70 font-body max-w-md">
              Open to Solutioning & Delivery leadership, GenAI / Agentic AI architecture and
              principal engineering roles. Consulting engagements welcome.
            </p>
          </div>

          <div className="md:col-span-7 grid sm:grid-cols-2 gap-4">
            {items.map((it, i) => (
              <motion.div
                key={it.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.06 }}
                data-testid={`contact-item-${it.id}`}
                className="glass rounded-2xl p-6 hover:border-[color:var(--primary)]/50 transition-all group"
              >
                <div className="flex items-center gap-2 text-xs font-mono-display uppercase tracking-widest text-white/50">
                  <it.icon size={14} className="text-[color:var(--primary)]" />
                  {it.label}
                </div>
                <div className="mt-3 flex items-center justify-between gap-3">
                  {it.href ? (
                    <a
                      href={it.href}
                      target={it.href.startsWith("http") ? "_blank" : undefined}
                      rel="noreferrer"
                      data-testid={`contact-link-${it.id}`}
                      className="font-mono-display text-base md:text-lg text-white hv-underline break-all"
                    >
                      {it.value}
                    </a>
                  ) : (
                    <span className="font-mono-display text-base md:text-lg text-white">{it.value}</span>
                  )}
                  <button
                    data-testid={`contact-copy-${it.id}`}
                    onClick={() => copy(it.value, it.id)}
                    className="opacity-0 group-hover:opacity-100 transition-opacity text-white/60 hover:text-[color:var(--accent)]"
                    aria-label={`Copy ${it.label}`}
                  >
                    {copied === it.id ? <Check size={16} /> : <Copy size={16} />}
                  </button>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;